export const ToolTip: number = 1
export const Modal: number = 2